module.exports = __webpack_public_path__ + "img/icon_protect.b147c879.svg";